import {
  EventType,
  CourseHit,
  LessonHit,
  SearchAnalyticsHelperOptions,
} from "./types";

declare global {
  interface Window {
    analytics: {
      track: (eventName: string, properties?: Record<string, unknown>) => void;
      user: () => {
        id: () => string | number | null | undefined;
      };
    };
  }
}
export class SearchAnalyticsHelper {
  constructor(private options: SearchAnalyticsHelperOptions) {}

  trackSearchResult(eventName: EventType, inputSource: string) {
    const properties = this.getCommonEventProperties(inputSource);
    const hitCounts = this.getHitCounts();

    window.analytics.track(eventName, {
      ...properties,
      ...hitCounts,
    });
  }

  trackLessonClick(event: Event, inputSource: string) {
    const hit = this.getHitData(event, "lesson") as unknown as LessonHit;
    const properties = this.getCommonEventProperties(inputSource);

    if (!hit) return;

    window.analytics.track(EventType.SearchResultTap, {
      type: "LESSON",
      course_title: hit.title,
      list_position: hit.__position - 1,
      maestro_name: hit.maestro.full_name,
      course_id: hit.record_id,
      lesson_id: hit.lesson.id,
      lesson_title: hit.lesson.title,
      ...properties,
    });
  }

  trackCourseClick(event: Event, inputSource: string) {
    const hit = this.getHitData(event, "course") as unknown as CourseHit;
    const properties = this.getCommonEventProperties(inputSource);

    if (!hit) return;

    window.analytics.track(EventType.SearchResultTap, {
      type: "COURSE",
      query: this.options.getQuery(),
      list_position: hit.__position - 1,
      course_title: hit.title,
      maestro_name: hit.maestro.full_name,
      course_id: hit.record_id,
      ...properties,
    });
  }

  private getHitData(
    event: Event,
    type: "course" | "lesson"
  ): Record<string, unknown> | undefined {
    const target = event.target as HTMLElement;
    const hitId = Number(target.closest("a")?.dataset.hitId);

    if (type === "course") {
      return this.options.courseHits.get(hitId);
    } else {
      return this.options.lessonHits.get(hitId);
    }
  }

  private getCommonEventProperties(inputSource: string) {
    const query = this.options.getQuery();

    return {
      query,
      platform: "web",
      user_id: Number(window.analytics.user().id()),
      input_source: inputSource,
    };
  }

  private getHitCounts() {
    const hitCounts = this.options.getHitCounts();

    return {
      num_hits: hitCounts.num_hits_courses + hitCounts.num_hits_lessons,
      num_hits_lessons: hitCounts.num_hits_lessons,
      num_hits_courses: hitCounts.num_hits_courses,
    };
  }
}
